import { USE_SHADOWS } from "@/helpers/GameConstants";

export const setCastShadow = (parent, castShadow = true) => {
  if (!USE_SHADOWS) {
    return;
  }
  parent.traverse(function (object) {
    if (object.isMesh) {
      object.castShadow = castShadow;
    }
  });
};

export const setReceiveShadow = (parent, receiveShadow = true) => {
  if (!USE_SHADOWS) {
    return;
  }
  parent.traverse(function (object) {
    if (object.isMesh) {
      object.receiveShadow = receiveShadow;
    }
  });
};

/**
 * Sets the layer of the object and all its children.
 * @param {*} object THREE object to set layer of
 * @param {*} layer layer to set
 */
export const setLayer = (object, layer) => {
  object.layers.set(layer);
  object.traverse((child) => {
    if (child.isMesh) {
      child.layers.set(layer);
    }
  });
};

/**
 * Example taken from https://discourse.threejs.org/t/cant-get-gltf-animation-to-play-but-it-works-in-the-gltf-viewer/14334
 * @param {*} gltf model
 * @param {*} name name of animation
 * @returns animation action
 */
export const getAnimation = (gltf, name) => {
  let result;
  gltf.animations.forEach((animation) => {
    if (animation.name === name) {
      result = animation;
    }
  });
  if (result == null) {
    console.error("animation: " + name + " cannot be found!");
  }
  return result;
};

export const isGrass = (object) => {
  return object.name.includes("Grass");
};

export const isTree = (object) => {
  return object.name.includes("Tree");
};

/**
 * Destructure map of bird instances into array
 * @param {*} birdMap map of bird instances
 * @returns array with all bird instances
 */
export const birdMapToArray = (birdMap) => {
  return Object.values(birdMap).reduce((acc, val) => acc.concat(val), []);
};

/**
 * Sets the shadow properties of a light object
 * TODO: Needs optimization review
 * @param {*} light THREE directional light object
 */
export const configureLightShadowSettings = (light) => {
  if (!USE_SHADOWS) {
    return;
  }
  // Set shadow camera size to be large enough to cover entire terrain
  const shadowCameraSize = 150;

  light.castShadow = true;
  light.shadow.camera.far = 1000;

  light.shadow.camera.top = shadowCameraSize;
  light.shadow.camera.bottom = -shadowCameraSize;
  light.shadow.camera.left = shadowCameraSize;
  light.shadow.camera.right = -shadowCameraSize;
  // Reduce shadow artifacts by increasing shadow map resolution and adding bias
  light.shadow.mapSize.width = window.innerWidth * 2;
  light.shadow.mapSize.height = window.innerHeight * 2;
  light.shadow.bias = -0.0001;
};

export const configureRendererShadowSettings = (renderer) => {
  if (!USE_SHADOWS) {
    return;
  }
  renderer.shadowMap.enabled = true;
};
